// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_fH","seoBlockContent_visible":"c-a_fJ"};